import { PDS } from "@pure-ds/core";
import { config } from "../../pds.config.js";
import { initHomeHydration } from "./pds-home-hydration.js";

// Start PDS with config
await PDS.start(config);

// Initialize client-side hydration for the static HTML
await initHomeHydration();